import React from "react";
import "./NewsCardList.scss";
import { Grid, Skeleton, Stack, Typography, Link } from "@mui/material";
import { getDate } from "../../utils/getDate";
import newsHrFallback from "../../assets/images/vijesti.svg";
import newsEnFallback from "../../assets/images/news.svg";
import pressReleasesHrFallback from "../../assets/images/priopcenja.svg";
import pressReleasesEnFallback from "../../assets/images/press-releases.svg";
import civilSocietyAndEuHrFallback from "../../assets/images/civilno-drustvo-i-eu.svg";
import civilSocietyAndEuEnFallback from "../../assets/images/civil-society-and-eu.svg";
import { News } from "../../shared/news-model";
import { useHistory } from "react-router-dom";
import {getStorageValue} from "../../utils/localStorageState";

type NewsCardListType = {
  isFetching: boolean;
  news: News[];
};

const resolveFallbackImage = (newsCategory: string) => {
  return {
    "Vijesti": newsHrFallback,
    "News": newsEnFallback,
    "Priopćenja": pressReleasesHrFallback,
    "Press releases": pressReleasesEnFallback,
    "Civilno društvo i EU": civilSocietyAndEuHrFallback,
    "Civil society and EU": civilSocietyAndEuEnFallback,
  }[newsCategory];
};

export default function NewsCardList({ isFetching, news }: NewsCardListType) {
  const history = useHistory();
  const langCode = getStorageValue("language", "hr");

  if (isFetching) {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4} marginBottom={2}>
          <Skeleton animation="wave" variant="rectangular" height={250} />
          <Stack padding={2} spacing={1}>
            <Skeleton animation="wave" height={12} width={100} />
            <Skeleton animation="wave" height={20} />
            <Skeleton animation="wave" height={20} />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={4} marginBottom={2}>
          <Skeleton animation="wave" variant="rectangular" height={250} />
          <Stack padding={2} spacing={1}>
            <Skeleton animation="wave" height={12} width={100} />
            <Skeleton animation="wave" height={20} />
            <Skeleton animation="wave" height={20} />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={4} marginBottom={2}>
          <Skeleton animation="wave" variant="rectangular" height={250} />
          <Stack padding={2} spacing={1}>
            <Skeleton animation="wave" height={12} width={100} />
            <Skeleton animation="wave" height={20} />
            <Skeleton animation="wave" height={20} />
          </Stack>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={3}>
      {news.map((item) => (
        <Grid item key={item.id} xs={12} sm={6} md={4} marginBottom={2}>
          <Link
            href={`/news/${item.attributes.slug}`}
            underline="none"
          >
            <Stack className="card-wrapper">
              <img
                src={item.attributes.mainImage ?? resolveFallbackImage(('hr' === langCode ? item.newsCategoryHr : item.newsCategoryEn) || '')}
                alt={item.attributes.mainImageAltText}
                className="card-img"
                style={{
                  backgroundColor: '#ececec',
                  objectFit: item.attributes.mainImage ? 'cover' : 'none',
                }}
              />
              <Stack
                sx={{
                  padding: "20px 12px",
                  marginTop: 2,
                }}
                spacing={1}
              >
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {getDate(item.attributes.lastTouchTime)}
                </Typography>
                <div className="card-title">
                  <Typography
                    gutterBottom
                    variant="h5"
                    color="text.primary"
                    component="div"
                  >
                    {item.attributes.title}
                  </Typography>
                </div>
              </Stack>
            </Stack>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
}
